import { useAPI } from "kw/api/useAPI";
import { useState } from "react";
import { Theme } from "baseui/theme";

export const useThemeOverrides = () => {
  const { query, loading } = useAPI();
  const loadThemeOverrides = async (callback: TCallbackFunction) => {
    return query(
      {
        loadTheme: {
          themeOverride: true,
          logo: {
            src: true,
            altText: true,
          },
        },
      },
      (response: { loadTheme: { themeOverride: Theme } }) => {
        callback(response?.loadTheme);
      }
    );
  };

  return { loadThemeOverrides, loading };
};
